import React, { Component } from 'react';
import { connect } from 'react-redux';
import DivisionCard from './DivisionCard';
import { CardDeck } from 'reactstrap';
import Disturber from './Disturber'
import '../styles/stepper.css';

export default class Home extends Component {
  constructor() {
    super();
    this.state = { isMaintenance: false }
  }
  componentDidMount() {
    fetch(`/test/getmaintenance`)
      .then(res => res.text())
      .then(result => this.setState({ isMaintenance: result === 'True' }));
  }
  render() {
    return (
      <div>
        {/*<Disturber />*/}
        <h1> Online Verwaltung von leerstehenden Mieteinheiten</h1>
        <p>Mit unserem Produkt GASAG | Leerstand bieten wir Ihnen besondere Konditionen für den Leerstandsverbrauch bei minimalem Verwaltungsaufwand. Für die Dauer eines Leerstandes entfallen die monatlichen Abschlagszahlungen. Wir bieten Ihnen eine schnelle und bequeme An- und Abmeldung von leerstehenden Mieteinheiten über unsere Online-Formulare. </p>
        {this.state.isMaintenance ?
          (<h2>Das Leerstandsportal steht zur Zeit leider nicht zur Verfügung.</h2>)
          :
          (<CardDeck>
            <DivisionCard
              filelinks={[
                { link: "https://www.gasag.de/-/media/gasagservice/documents/vertriebsunterlagen/preisblaetter/leerstand/Preisblatt_GASAG-ERDGAS-Leerstand_aktuell", name: "Preisblatt – GASAG | ERDGAS Leerstand" },
                { link: "https://www.gasag.de/-/media/gasagservice/documents/vertriebsunterlagen/agb/agb-leerstand/A_GA_LEER_20230925", name: "AGB inkl. Widerrufsbelehrung" },
                { link: "https://www.gasag.de/-/media/gasagservice/documents/vertriebsunterlagen/produktdatenschutzhinweise/GASAG-Datenschutzhinweise_aktuell.pdf", name: "Datenschutzhinweise" },
                { link: "https://www.gasag.de/-/media/gasagservice/documents/vertriebsunterlagen/Information-Energiepreisbremsen/GASAG_Info_GPB_TarifP_aktuell.pdf", name: "Informationen zur Gaspreisbremse" }
              ]}
              title="GASAG | ERDGAS Leerstand"
              introduction="Ihr Erdgas-Leerstand hat einen Verbrauch von maximal 400 kWh, dann zahlen Sie nichts. Übersteigt der Verbrauch die Grenze von 400 kWh, wird der gesamte Verbrauch ohne Abzug der Freimenge zu den Konditionen des Produktes GASAG | ERDGAS Leerstand abgerechnet."
              buttons={[{ text: "ERDGAS Leerstand anmelden", navigateTo: '/RegisterGas' }, { text: "ERDGAS Leerstand abmelden", navigateTo: '/CancelGas' }]}
              buttonInfo="Nur für Mietobjekte in Berlin verfügbar."
            />

            <DivisionCard
              filelinks={[
                { link: "https://www.gasag.de/-/media/gasagservice/Dokumente/vertriebsunterlagen/preisblaetter/leerstand/Preisblatt_GASAG-STROM-Leerstand_aktuell", name: "Preisblatt – GASAG | STROM Leerstand" },
                { link: "https://www.gasag.de/-/media/gasagservice/documents/vertriebsunterlagen/agb/agb-leerstand/A_GA_LEER_20230925", name: "AGB inkl. Widerrufsbelehrung" },
                { link: "https://www.gasag.de/-/media/gasagservice/documents/vertriebsunterlagen/produktdatenschutzhinweise/GASAG-Datenschutzhinweise_aktuell.pdf", name: "Datenschutzhinweise" },
                { link: "https://www.gasag.de/-/media/GASAGService/Dokumente/vertriebsunterlagen/stromkennzeichnung/GASAG-Stromkennzeichnung_Web_aktuell", name: "GASAG-Stromkennzeichnung" },
                { link: "https://www.gasag.de/-/media/gasagservice/documents/vertriebsunterlagen/Information-Energiepreisbremsen/GASAG_Info_SPB_TarifP_aktuell.pdf", name: "Informationen zur Strompreisbremse" }
              ]}
              title="GASAG | STROM Leerstand"
              introduction="Ihr Strom-Leerstand dauert maximal 60 Tage und übersteigt einen Verbrauch von 40 kWh nicht, dann zahlen Sie nichts. Übersteigt der Verbrauch in Menge und/oder Dauer eine dieser Grenzen, wird der gesamte Verbrauch ohne Abzug der Freimenge zu den Konditionen des Produktes GASAG | STROM Leerstand abgerechnet."
              buttons={[{ text: "STROM Leerstand anmelden", navigateTo: '/RegisterElectricity' }, { text: "STROM Leerstand abmelden", navigateTo: '/CancelElectricity' }]}
              buttonInfo="Nur für Mietobjekte mit Allgemeinstromversorgung der GASAG verfügbar.                                           
        Nur in Berlin und einzelnen Netzgebieten verfügbar. Welche Netzgebiete für das Produkt verfügbar sind, können Sie dem Preisblatt entnehmen."
            />
          </CardDeck>)}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Home.js